/**
 * EmptyState — neutral, centered placeholder for empty lists/tables.
 */
import type { CSSProperties, ReactNode } from 'react';
import { colors } from '../theme';

export interface EmptyStateProps {
  /** Optional leading glyph (unicode/emoji or inline SVG). */
  icon?: ReactNode;
  title: string;
  description?: string;
  /** Optional action (e.g. a primary button). */
  action?: ReactNode;
  style?: CSSProperties;
}

export function EmptyState({ icon, title, description, action, style }: EmptyStateProps) {
  return (
    <div style={{ ...wrap, ...style }}>
      {icon && <div style={iconStyle}>{icon}</div>}
      <div style={titleStyle}>{title}</div>
      {description && <div style={descStyle}>{description}</div>}
      {action && <div style={{ marginTop: 12 }}>{action}</div>}
    </div>
  );
}

const wrap: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '40px 24px',
  color: colors.textSecondary,
};
const iconStyle: CSSProperties = { fontSize: '1.8rem', marginBottom: 8, opacity: 0.7 };
const titleStyle: CSSProperties = { fontSize: '0.95rem', fontWeight: 600, color: colors.textPrimary };
const descStyle: CSSProperties = { fontSize: '0.86rem', color: colors.textSecondary, marginTop: 4, maxWidth: 360 };
